declare var angular : any

const DOMPurify = require("dompurify");

class ParamUtilService {

  // copy the whole obj (instead of directly modifying it)
  // but leaves out the keys where value === unwanted_value
  public sanitize(obj, unwanted_value): Object {
    let sanitized_obj = {}
    for (let key in obj) {
      let value = obj[key]
      if (value != null && value instanceof Object) {
        sanitized_obj[key] = this.sanitize(value, unwanted_value)
      } else if (!(typeof value === 'string' && value === unwanted_value)) {
        // add the key and value only if the value is not unwanted
        sanitized_obj[key] = value
      }
    }
    return sanitized_obj
  }

  public removeKeysWithEmptyString(obj): Object {
    return this.sanitize(obj, "")
  }

  public sanitizeHtml(html: string): string {
    if (!html || typeof html !== "string") return html;

    return this.sanitizeWithDomPurify(html);
  }

  private sanitizeWithDomPurify(html: string): string {
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: [],           // No HTML tags allowed 
      ALLOWED_ATTR: [],           // No attributes allowed
      KEEP_CONTENT: true,         // Keep text content
      SANITIZE_DOM: true,         // Extra DOM sanitization
      WHOLE_DOCUMENT: false,      // Only sanitize fragment
    });
  }
}

angular.module("BookingApp").service("ParamUtilService", ParamUtilService)
